var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Collection, getEnumValue, compile } from '@syncfusion/ej2-base';
import { Internationalization } from '@syncfusion/ej2-base';
import { CellType } from '@syncfusion/ej2-grids';
/**
 * Configures the aggregate column for the TreeGrid.
 */
export class AggregateColumn extends ChildProperty {
    constructor() {
        super(...arguments);
        this.intl = new Internationalization();
        this.templateFn = {};
    }
    /**
     * Custom format function
     *
     * @hidden
     * @param {string} cultureName - culture name to format
     * @returns {void}
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setFormatter(cultureName) {
        if (this.format && (this.format.skeleton || this.format.format)) {
            this.formatFn = this.getFormatFunction(this.format);
        }
    }
    /**
     * @param {NumberFormatOptions | DateFormatOptions} format - formatting options for number and date values
     * @hidden
     * @returns {Function} - return formatter function
     */
    getFormatFunction(format) {
        if (format.type) {
            return this.intl.getDateFormat(format);
        }
        else {
            return this.intl.getNumberFormat(format);
        }
    }
    /**
     * @hidden
     * @returns {Function} - Returns formatter function
     */
    getFormatter() {
        return this.formatFn;
    }
    /**
     * @param {Object} helper - Specified the helper
     * @hidden
     * @returns {void}
     */
    setTemplate(helper = {}) {
        if (this.footerTemplate !== undefined) {
            this.templateFn[getEnumValue(CellType, CellType.Summary)] = { fn: compile(this.footerTemplate, helper),
                property: 'footerTemplate' };
        }
    }
    /**
     * @param {CellType} type - specifies the cell type
     * @returns {Object} returns the object
     * @hidden
     */
    getTemplate(type) {
        return this.templateFn[getEnumValue(CellType, type)];
    }
    /**
     * @param {Object} prop - updates aggregate properties without change detection
     * @hidden
     * @returns {void}
     */
    setPropertiesSilent(prop) {
        this.setProperties(prop, true);
    }
}
__decorate([
    Property()
], AggregateColumn.prototype, "type", void 0);
__decorate([
    Property()
], AggregateColumn.prototype, "footerTemplate", void 0);
__decorate([
    Property()
], AggregateColumn.prototype, "field", void 0);
__decorate([
    Property()
], AggregateColumn.prototype, "format", void 0);
__decorate([
    Property()
], AggregateColumn.prototype, "columnName", void 0);
__decorate([
    Property()
], AggregateColumn.prototype, "customAggregate", void 0);
/**
 * Configures the aggregate rows in the TreeGrid.
 */
export class AggregateRow extends ChildProperty {
}
__decorate([
    Collection([], AggregateColumn)
], AggregateRow.prototype, "columns", void 0);
__decorate([
    Property(true)
], AggregateRow.prototype, "showChildSummary", void 0);
